export const STATUS_TABS = {
  booked: { label: "Upcoming", count: 0 },
  requested: { label: "Requests", count: 0 },
  completed: { label: "Completed", count: 0 },
  canceled: { label: "Canceled", count: 0 }
}

export const REQUEST_TYPES = {
  upcoming: "booked",
  requested: "requested",
  completed: "completed",
  canceled: "canceled"
}

export const PAYMENT_STATUS = {
  partial: "partial",
  paid: "full_paid",
  partial_refund: "partial_refund"
}

export const getTimePeriods = (t) => ({
  day: t("bookings.day"),
  month: t("bookings.month"),
  year: t("bookings.year")
})

export const getStatusMessages = (t) => ({
  booked: {
    title: t("bookings.upcoming_title"),
    description: t("bookings.upcoming_description")
  },
  requested: {
    title: t("bookings.requests_title"),
    description: t("bookings.requests_description")
  },
  completed: {
    title: t("bookings.completed_title"),
    description: t("bookings.completed_description")
  },
  canceled: {
    title: t("bookings.canceled_title"),
    description: t("bookings.canceled_description")
  }
})

export const PAYMENT_OPTIONS = {
  deposit_later: "deposit_and_balance_later",
  deposit_cash: "deposit_and_balance_in_cash",
  full_now: "full_amount_today",
  full_cash: "full_amount_in_cash_on_day",
  full_link: "full_amount_by_link",
  deposit_link: "deposit_by_link_and_balance_later",
  deposit_link_in_cash: "deposit_by_link_and_balance_in_cash",
  pay_later: "pay_later"
}

export const initialValues = {
  isExistingClient: false,
  existing_client: null,
  firstName: "",
  lastName: "",
  email: "",
  phone_number: null,
  experience: null,
  date: null,
  duration: null,
  time: null,
  accessibility_required: false,
  accessibility_notes: "",
  notes: "",
  depositOnly: false,
  depositPercent: null,
  customDepositAmount: null,
  paymentOption: "",
  paymentType: undefined,
  collectPayment: "yes",
  recordPayment: 0,
  refundBy: ""
}

export const REFUND_CANCEL_REASONS = ["Equipment Issues", "Weather", "Pro or Employee Unavailable"]

export const BOOKING_SOURCE = {
  marketplace: "marketplace",
  manual: "manual",
  embedded: "embedded",
  website: "website"
}

export const BOOKING_MODES = {
  embedded: "embedded",
  clientBooking: "clientBooking",
  guideProfile: "guideProfile"
}
